// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZAWJE{display:grid}.ZAWJE>*{grid-area:1/1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayStack": `ZAWJE`
};
export default ___CSS_LOADER_EXPORT___;
